import React from 'react';
import {Checkbox, DatePicker, Form, Icon, Input, Select} from 'antd';
import PropTypes from 'prop-types';
import MasterModal from "../MasterModal";
import DocumentList from "../../components/DocumentList";
import DocumentList2 from "../../components/PreApprovalDocumentList";
import SuperMasterModal from '../SuperMasterModal'
import moment from "moment";

const {TextArea} = Input;

class SubList extends React.Component {
    id = 0;
    readingKeys = [];
    state = {
        keys: [],
        keys2: [],
        documentData: {},
        addOn: false,
        assetDocumentData: {},
        assetTypeChanged: false,
        assetSubTypeChanged: false,
    };

    componentDidMount() {
        const {data = [{}]} = this.props;
        this.setState({
            keys: data,
        });
        if (this.props.field && this.props.field.photos && this.props.field.photos.length) {
            this.props.form.setFieldsValue({[`assetDetails[${this.props.index}]['photos']`]: this.props.field.photos});
        }
    }

    clearDocumentData() {
        this.setState({documentData: {}});
    }

    clearKeys2Data() {
        this.setState({keys2: []});
    }

    getDocumentData = (index, data) => {
        this.props.form.setFieldsValue({[`assetDetails[${index}]['photos']`]: data});
        this.props.updateDocumentData(data);
        this.setState({documentData: data});
    };

    getAssetDocumentData = (index, data) => {
        this.props.form.setFieldsValue({[`assetDetails[${index}]['documents']`]: data});
        this.props.updateAssetDocumentData(data);
        this.setState({assetDocumentData: data});
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.field && nextProps.field['reading']) {
            this.readingKeys.push(nextProps.field['reading']);
        }
        if (nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
            this.setState({
                keys: nextProps.data,
            });
        }
    }

    removeInterval = (index, idx) => {
        const {keys2} = this.state;
        const {form, filters} = this.props;
        const item = filters && filters['assetDetails'] && filters['assetDetails']['schema'] && filters['assetDetails']['schema']['reading'];
        const val = form.getFieldValue('assetDetails')[`${index}`]['reading'];
        val.splice(idx, 1);
        this.readingKeys[index].splice(idx, 1);
        for (let i = 0; i < val.length; i++) {
            Object.keys(item.schema).map((itm, kk) => {
                form.setFieldsValue({
                    [`assetDetails[${index}]['reading'][${i}]['${itm}']`]: val[i][`${itm}`],
                });
            });
        }
    };

    assetFormItems(index, data) {
        const {form, filters, title, resource, field} = this.props;
        const {getFieldDecorator} = form;
        const {keys2} = this.state;
        const style = {
            marginTop: '10px',
            width: '100%',
            border: '1px dashed #000',
            padding: '20px',
            borderRadius: '9px',
        };
        return this.readingKeys && this.readingKeys[index] && this.readingKeys[index].length && this.readingKeys[index].map((k, fIndex) => {
            return <div key={`L${fIndex}`} style={style}>
                <Form.Item key={`${fIndex}1`} label={'Meter'}>
                    {getFieldDecorator(`assetDetails[${index}]['reading'][${fIndex}]['meter']`, {
                        initialValue: (field && field['reading'] && field['reading'][fIndex] && field['reading'][fIndex].meter) || '',
                    })(<Input type='number'
                              onWheel={event => event.currentTarget.blur()}
                              placeholder={'Meter'}
                              disabled={title === 'VIEW'} style={{width: '100%'}}/>)

                    }
                </Form.Item>
                <Form.Item key={`${fIndex}2`} label={'Meter Unit'}>
                    {getFieldDecorator(`assetDetails[${index}]['reading'][${fIndex}]['meterUnit']`, {
                        initialValue: (field && field['reading'] && field['reading'][fIndex] && field['reading'][fIndex].meterUnit) || '',
                    })(<Select
                        showSearch
                        allowClear
                        mode="single"
                        disabled={title === 'VIEW'}
                        placeholder={`Please Select Meter Unit`}
                        style={{width: '100%'}}
                        filterOption={(input, option) =>
                            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                        }
                    >
                        {filters && filters['assetDetails'] && filters['assetDetails']['schema'] && filters['assetDetails']['schema']['reading']['schema']['meterUnit'].data.data.map(item =>
                            <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                    </Select>)
                    }
                </Form.Item>

                {fIndex >= 0 ? (
                    <Icon
                        disabled={this.props.tempAssetCode !== '' || title === 'VIEW'}
                        className="dynamic-delete-button"
                        type="minus-circle-o"
                        onClick={() => this.removeInterval(index, fIndex)}
                    />
                ) : null}
            </div>
        });
    }

    remove = index => {
        const {keys} = this.state;
        const {form, item} = this.props;
        const {field} = item;
        if (keys.length === 1) {
            return;
        }
        const val = form.getFieldValue(field);
        val.splice(index, 1);

        keys.splice(index, 1);
        for (let i = 0; i < val.length; i++) {
            Object.keys(item.schema).map((item, index) => {
                form.setFieldsValue({
                    [`${field}[${i}][${item}]`]: val[i][item],
                });
            });
        }
        this.setState({
            keys: keys,
        });
    };

    addInterval = () => {
        const {item: {field}} = this.props;
        const {keys2} = this.state;
        keys2.push(`${field}${this.id++}`);
        this.setState({
            keys2: keys2,
        });
    };

    handleSelectAssetType = (values, index) => {
        this.props.handleSelectAssetType(values);
        this.props.form.setFieldsValue({[`assetDetails[${index}]['equipmentSubType']`]: ''});
        this.props.form.setFieldsValue({[`assetDetails[${index}]['assetModel']`]: ''});
        this.setState({assetTypeChanged: true});
    }

    handleSelectAssetSubType = (values, index) => {
        this.props.handleSelectAssetSubType(values);
        this.props.form.setFieldsValue({[`assetDetails[${index}]['assetModel']`]: ''});
        this.setState({assetSubTypeChanged: true});
    }

    add = () => {
        const {item: {field}} = this.props;
        const {keys} = this.state;
        keys.push(`${field}${this.id++}`);
        this.setState({
            keys: keys,
        });
    };

    render() {
        const {
            form,
            item,
            data = [],
            resource,
            index,
            match,
            history,
            getDocumentData,
            title,
            latitude,
            longitude,
            superMaster,
            subMaster,
            tempAssetCode,
            documentData,
            subDocumentFilters,
            field,
            pvData,
        } = this.props;
        const {getFieldDecorator, setFieldsValue} = form;
        const {keys} = this.state;
        const {changeCountable, checked, filters, assetSubTypes, assetModels} = this.props;
        const style = {
            marginTop: '10px',
            border: '1px dashed #000',
            padding: '10px',
            borderRadius: '9px',
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            wordBreak: 'break-all',
        };

        const formItems = (index) => {
            return <div key={`asset-stock${index}`} style={style}>
                <Form.Item key={'assetType'} label={'Asset Type'}>
                    {getFieldDecorator(`assetDetails[${index}]['assetType']`, {
                        initialValue: this.props.field && this.props.field.assetType && this.props.field.assetType._id,
                    })(<Select
                        showSearch
                        allowClear
                        mode="single"
                        disabled={title === 'VIEW'}
                        onSelect={(e, ind) => {
                            this.handleSelectAssetType(e, index)
                        }}
                        style={{width: '75%'}}
                        filterOption={(input, option) =>
                            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                        }
                        placeholder={`Please Select Asset Type`}
                    >
                        {item && item.schema && item.schema['assetType'].data && item.schema['assetType'].data.data && item.schema['assetType'].data.data.length && item.schema['assetType'].data.data.map(itm =>
                            <Select.Option key={itm._id} value={itm._id}>{itm.name}</Select.Option>)}
                    </Select>)
                    }
                    {
                        item && item.schema && item.schema['assetType'].options.master ?
                            <MasterModal superMaster={superMaster || false}
                                         subMaster={subMaster || false}
                                         resource={resource} item={item.schema['assetType'].options.ref || ''}
                                         title={'CREATE'}/> : ''
                    }
                </Form.Item>

                <Form.Item key={'equipmentSubType'} label={'Equipment Sub Type'}>
                    {getFieldDecorator(`assetDetails[${index}]['equipmentSubType']`, {
                        initialValue: this.props.field && this.props.field.equipmentSubType && this.props.field.equipmentSubType._id,
                    })(<Select
                        showSearch
                        allowClear
                        mode="single"
                        onSelect={(e, ind) => {
                            this.handleSelectAssetSubType(e, index)
                        }}
                        disabled={title === 'VIEW'}
                        style={{width: '75%'}}
                        filterOption={(input, option) =>
                            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                        }
                        placeholder={`Please Select Equipment Sub Type`}
                    >
                        {
                            this.state.assetTypeChanged && this.props.assetSubTypes && this.props.assetSubTypes.length ? this.props.assetSubTypes.map(itm => (
                                <Select.Option key={itm._id}
                                               value={itm._id}>{itm.name}</Select.Option>)) : !this.state.assetTypeChanged && item && item.schema && item.schema['equipmentSubType'].data
                                && item.schema['equipmentSubType'].data.data && item.schema['equipmentSubType'].data.data.length && item.schema['equipmentSubType'].data.data.map(itm =>
                                    <Select.Option key={itm._id} value={itm._id}>{itm.name}</Select.Option>)
                        }
                    </Select>)
                    }
                    {
                        item && item.schema && item.schema['equipmentSubType'].options.master ?
                            <MasterModal superMaster={superMaster || false}
                                         handleSelectAssetType={this.props.handleSelectAssetType}
                                         subMaster={subMaster || false}
                                         index={this.props.index}
                                         form2={this.props.form}
                                         resource={resource} item={item.schema['equipmentSubType'].options.ref}
                                         title={'CREATE'}/> : ''
                    }
                </Form.Item>

                <Form.Item key={'assetModel'} label={'Asset Model'}>
                    {getFieldDecorator(`assetDetails[${index}]['assetModel']`, {
                        rules: [{
                            required: true,
                            message: `Asset Model is required!`
                        }],
                        initialValue: this.props.field && this.props.field.assetModel && this.props.field.assetModel._id,
                    })(<Select
                        showSearch
                        allowClear
                        mode="single"
                        onSelect={this.handleSelectAssetType}
                        style={{width: '75%'}}
                        filterOption={(input, option) =>
                            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                        }
                        disabled={title === 'VIEW'}
                        placeholder={`Please Select Asset Model`}
                    >{
                        this.state.assetSubTypeChanged && this.props.assetModels && this.props.assetModels.length ? this.props.assetModels.map(itm => (
                            <Select.Option key={itm._id}
                                           value={itm._id}>{itm.name}</Select.Option>)) : !this.state.assetSubTypeChanged && item && item.schema && item.schema['assetModel'].data &&
                            item.schema['assetModel'].data.data && item.schema['assetModel'].data.data.length && item.schema['assetModel'].data.data.map(itm =>
                                <Select.Option key={itm._id} value={itm._id}>{itm.name}</Select.Option>)}
                    </Select>)
                    }
                    {
                        item && item.schema && item.schema['assetModel'].options.master ?
                            <SuperMasterModal superMaster={superMaster || false}
                                              subMaster={subMaster || false} form2={this.props.form}
                                              index={this.props.index}
                                              handleSelectAssetSubType={this.props.handleSelectAssetSubType}
                                              resource={resource} item={item.schema['assetModel'].options.ref}
                                              title={'CREATE'}/> : ''
                    }
                </Form.Item>

                <Form.Item key={'physicalCondition'} label={'Physical Condition'}>
                    {getFieldDecorator(`assetDetails[${index}]['physicalCondition']`, {
                        rules: [{
                            required: true,
                            message: `Physical Condition is required!`
                        }],
                        initialValue: this.props.field && this.props.field['physicalCondition'] && this.props.field['physicalCondition']['_id'],
                    })(<Select
                        showSearch
                        allowClear
                        mode="single"
                        style={{width: '75%'}}
                        filterOption={(input, option) =>
                            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                        }
                        disabled={title === 'VIEW'}
                        placeholder={`Please Select Physical Condition`}
                    >
                        {item && item.schema && item.schema['physicalCondition'].data && item.schema['physicalCondition'].data.data && item.schema['physicalCondition'].data.data.length && item.schema['physicalCondition'].data.data.map(itm =>
                            <Select.Option key={itm._id} value={itm._id}>{itm.name}</Select.Option>)}
                    </Select>)
                    }
                    {
                        item && item.schema && item.schema['physicalCondition'].options.master ?
                            <MasterModal superMaster={superMaster || false}
                                         subMaster={subMaster || false}
                                         resource={resource} item={item.schema['physicalCondition'].options.ref}
                                         title={'CREATE'}/> : ''
                    }
                </Form.Item>

                <Form.Item key={'countable'}>
                    {getFieldDecorator(`assetDetails[${index}]['countable']`, {
                        valuePropName: 'checked',
                        initialValue: this.props.field && this.props.field['countable'],
                    })(<Checkbox disabled={true}>
                        Countable</Checkbox>)
                    }
                </Form.Item>

                {this.props.field && this.props.field['countable'] ?
                    <Form.Item key={'qty'} label={'Enter Quantity'}>
                        {getFieldDecorator(`assetDetails[${index}]['qty']`, {
                            initialValue: (this.props.field && this.props.field['qty']),
                        })(<Input type='number'
                                  onWheel={event => event.currentTarget.blur()}
                                  placeholder={'Enter Quantity'}
                                  disabled={title === 'VIEW'}
                                  style={{marginRight: 8, width: '75%'}}/>)
                        }
                    </Form.Item> : <> </>
                }

                {
                    !(this.props.field && this.props.field['countable']) ?
                        <Form.Item key={'serialNumber'} label={'Serial Number'}>
                            {getFieldDecorator(`assetDetails[${index}]['serialNumber']`, {
                                initialValue: this.props.field && this.props.field['serialNumber'],
                            })(<Input style={{marginRight: 8, width: '75%'}} disabled={title === 'VIEW'}
                                      placeholder={'Enter Serial Number'}/>)
                            }
                        </Form.Item> : <> </>
                }

                {
                    !(this.props.field && this.props.field['countable']) ?
                        <Form.Item key={'existingAssetCode'} label={'Existing Asset Code'}>
                            {getFieldDecorator(`assetDetails[${index}]['existingAssetCode']`, {
                                initialValue: this.props.field && this.props.field['existingAssetCode'],
                            })(<Input style={{marginRight: 8, width: '75%'}} disabled={title === 'VIEW'} type={"text"}
                                      placeholder={'Enter Existing Asset Code'}/>)
                            }
                        </Form.Item> : <> </>
                }

                {
                    !(this.props.field && this.props.field['countable']) ?
                        <Form.Item key={'assetCustodian'} label={'Asset Custodian'}>
                            {getFieldDecorator(`assetDetails[${index}]['assetCustodian']`, {
                                rules: [{
                                    required: false,
                                    message: `Asset Custodian is required!`
                                }],
                                initialValue: this.props.field && this.props.field['assetCustodian'] && this.props.field['assetCustodian']['_id'],
                            })(<Select
                                showSearch
                                allowClear
                                mode="single"
                                style={{width: '75%'}}
                                filterOption={(input, option) =>
                                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                }
                                disabled={title === 'VIEW'}
                                placeholder={`Please Select Asset Custodian`}
                            >
                                {item && item.schema && item.schema['assetCustodian'].data && item.schema['assetCustodian'].data.data && item.schema['assetCustodian'].data.data.length
                                    && item.schema['assetCustodian'].data.data.map(itm =>
                                        <Select.Option key={itm._id} value={itm._id}>{itm.name}</Select.Option>)}
                            </Select>)
                            }
                            {
                                item && item.schema && item.schema['assetCustodian'].options.master ?
                                    <MasterModal superMaster={superMaster || false}
                                                 subMaster={subMaster || false}
                                                 resource={resource} item={item.schema['assetCustodian'].options.ref}
                                                 title={'CREATE'}/> : ''
                            }
                        </Form.Item> : <> </>
                }

                {/*{*/}
                {/*  !(this.props.field && this.props.field['countable']) ?*/}
                {/*    <Form.Item key={'assetCustodian'} label={'Asset Custodian'}>*/}
                {/*      {getFieldDecorator(`assetDetails[${index}]['assetCustodian']`, {*/}
                {/*        initialValue: this.props.field && this.props.field['assetCustodian'],*/}
                {/*      })(<Input style={{marginRight: 8, width: '75%'}} disabled={title === 'VIEW'} type={"text"}*/}
                {/*                placeholder={'Enter Asset Custodian'}/>)*/}
                {/*      }*/}
                {/*    </Form.Item> : <> </>*/}
                {/*}*/}

                {
                    !(this.props.field && this.props.field['countable']) ?
                        <Form.Item key={'utilisationLevel'} label='Utilisation Level'>
                            {getFieldDecorator(`assetDetails[${index}]['utilisationLevel']`, {
                                initialValue: this.props.field && this.props.field['utilisationLevel'],
                            })(<Select allowClear
                                       style={{marginRight: 8, width: '75%'}} disabled={title === 'VIEW'}
                                       placeholder={`Please select Utilisation Level`}
                            >
                                {item && item.options && item.options['utilisationLevel'] && item.options['utilisationLevel'].enum &&
                                    item.options['utilisationLevel'].enum.length && item.options['utilisationLevel'].enum.map(item =>
                                        <Select.Option
                                            key={item} value={item}>{item}</Select.Option>)}
                            </Select>)
                            }
                        </Form.Item> : <> </>
                }
                {
                    !(this.props.field && this.props.field['countable']) ?
                        <Form.Item key={'parentAssetCode'} label='Parent Asset Code'>
                            {getFieldDecorator(`assetDetails[${index}]['parentAssetCode']`, {
                                initialValue: this.props.field && this.props.field['parentAssetCode'],
                            })(<Select
                                showSearch
                                allowClear
                                mode="single"
                                disabled={title === 'VIEW'}
                                style={{marginRight: 8, width: '75%'}}
                                filterOption={(input, option) =>
                                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                }
                                placeholder="Please select parent asset code"
                            >
                                {
                                    pvData && pvData.length
                                    && pvData.map(item => {
                                        return item && item.assetDetails && item.assetDetails.length &&
                                            item.assetDetails.map(itm => {
                                                return <Select.Option
                                                    key={itm.tempAssetCode}
                                                    value={itm.tempAssetCode}>{itm.tempAssetCode}
                                                </Select.Option>
                                            });
                                    })
                                }
                            </Select>)}
                        </Form.Item> : <> </>
                }

                {
                    <Form.Item key={`assetDetails[${index}]['tempAssetCode']`} label={'Temp Id'}>
                        {getFieldDecorator(`assetDetails[${index}]['tempAssetCode']`, {
                            initialValue: this.props.field && this.props.field['tempAssetCode'],
                        })(<Input style={{marginRight: 8, width: '75%', fontWeight: 'bold'}}
                                  disabled={true} type={"text"}/>)
                        }
                    </Form.Item>
                }
                {
                    <Form.Item key={`assetDetails[${index}]['tempQrCode']`} label={'QR Id'}>
                        {getFieldDecorator(`assetDetails[${index}]['tempQrCode']`, {
                            initialValue: this.props.field && this.props.field['tempQrCode'],
                        })(<Input style={{marginRight: 8, width: '75%', fontWeight: 'bold'}}
                                  disabled={true} type={"text"}/>)
                        }
                    </Form.Item>
                }

                {
                    <Form.Item key={`assetDetails[${index}]['tag_type']`} label={'Tag Type'}>
                        {getFieldDecorator(`assetDetails[${index}]['tag_type']`, {
                            initialValue: this.props.field && this.props.field['tag_type'] && this.props.field['tag_type']['_id'],
                        })(<Select style={{marginRight: 8, width: '75%', fontWeight: 'bold'}}
                                   disabled={true}>
                            {
                                <Select.Option key={this.props.field && this.props.field['tag_type'] && this.props.field['tag_type']['_id']}
                                               value={this.props.field && this.props.field['tag_type'] && this.props.field['tag_type']['_id']}>
                                    {this.props.field && this.props.field['tag_type'] && this.props.field['tag_type']['name']}
                                </Select.Option>
                            }
                        </Select>)
                        }
                    </Form.Item>
                }
                {
                    title === 'VIEW' ? <Form.Item key={`assetDetails[${index}]['assetCode']`} label={'Asset Code'}>
                        {getFieldDecorator(`assetDetails[${index}]['assetCode']`, {
                            initialValue: this.props.field && this.props.field['assetCode'],
                        })(<Input.TextArea style={{marginRight: 8, width: '75%'}} disabled={true} rows={4}/>)
                        }
                    </Form.Item> : <> </>
                }
                {
                    !(this.props.field && this.props.field['countable']) && this.props.field['reading'] && this.props.field['reading'].length ?
                        <>
                            {this.assetFormItems(index, this.props.field['reading'])}
                        </> : <></>
                }
                {
                    <div key={`assetDetails[${index}]['photos']`}>
                        <Form.Item key={`assetDetails[${index}]['photos']`} style={{width: '100%'}}>
                            {getFieldDecorator(`assetDetails[${index}]['photos']`, {})(<DocumentList
                                match={this.props.match}
                                history={this.props.history}
                                resource={'PreVerificationApproval'}
                                key={item}
                                item={filters && filters['assetDetails'] && filters['assetDetails']['schema'] && filters['assetDetails']['schema']['photos']}
                                form={form}
                                data={this.props.field['photos'] || []}
                                subDocumentFilters={subDocumentFilters}
                                title={title} index={index}
                                hideRemove={title === 'VIEW'}
                                hideEdit={true}
                                getDocumentData={this.getDocumentData}/>)}
                        </Form.Item>
                    </div>
                }

                <Form.Item key={'ownedBy'} label={'Owned By'}>
                    {getFieldDecorator(`assetDetails[${index}]['ownedBy']`, {
                        rules: [{
                            required: true,
                            message: `Asset Owner is required!`
                        }],
                        initialValue: this.props.field && this.props.field['ownedBy'] && this.props.field['ownedBy']['_id'],
                    })(<Select
                        showSearch
                        allowClear
                        mode="single"
                        disabled={title === 'VIEW'}
                        style={{width: '75%'}}
                        filterOption={(input, option) =>
                            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                        }
                        placeholder={`Please Select Owner`}
                    >
                        {item && item.schema && item.schema['ownedBy'] && item.schema['ownedBy'].data && item.schema['ownedBy'].data.data && item.schema['ownedBy'].data.data.length && item.schema['ownedBy'].data.data.map(itm =>
                            <Select.Option key={itm._id} value={itm._id}>{itm.name}</Select.Option>)}
                    </Select>)
                    }
                    {
                        item && item.schema && item.schema['ownedBy'].options.master ?
                            <MasterModal superMaster={superMaster || false}
                                         subMaster={subMaster || false}
                                         resource={resource} item={item.schema['ownedBy'].options.ref}
                                         title={'CREATE'}/> : ''
                    }
                </Form.Item>

                <Form.Item key={'invoiceDate'} label={'Invoice Date'}>
                    {getFieldDecorator(`assetDetails[${index}]invoiceDate`, {
                        initialValue: this.props.field && this.props.field.invoiceDate && moment(this.props.field.invoiceDate),
                    })(<DatePicker
                        style={{width: '75%'}}
                        disabled={title === 'VIEW'}
                    />)
                    }
                </Form.Item>

                <Form.Item key={'invoiceValue'} label={'Invoice Value'}>
                    {getFieldDecorator(`assetDetails[${index}]['rate']`, {
                        rules: [{
                            required: true,
                            message: `Invoice Value of an asset is required!`
                        }],
                        initialValue: this.props.field && this.props.field.rate,
                    })(<Input style={{width: '75%'}}
                              type="number"
                              onWheel={event => event.currentTarget.blur()}
                              disabled={title === 'VIEW'}/>
                    )}
                </Form.Item>

                <Form.Item key={'alt'} label={'Alt Name'}>
                    {getFieldDecorator(`assetDetails[${index}]['altName']`, {
                        initialValue: this.props.field && this.props.field.altName,
                    })(<Input style={{width: '75%'}} type="text" disabled={title === 'VIEW'}/>)
                    }
                </Form.Item>

                <Form.Item key={'description'} label={'Description'}>
                    {getFieldDecorator(`assetDetails[${index}]['description']`, {
                        initialValue: this.props.field && this.props.field.description,
                    })(<Input style={{width: '75%'}} type="text" disabled={title === 'VIEW'}/>)
                    }
                </Form.Item>

                <div>
                    <Form.Item></Form.Item>
                </div>

                <div key={`assetDocuments${[index]}`} style={{width: '100%'}}>
                    <Form.Item key={`assetDetails[${index}]['documents']`} style={{width: '100%'}}>
                        {getFieldDecorator(`assetDetails[${index}]['documents']`, {})(<DocumentList2
                            match={this.props.match}
                            history={this.props.history}
                            resource={'AssetDocuments'}
                            key={item}
                            item={filters && filters['assetDetails'] && filters['assetDetails']['schema'] && filters['assetDetails']['schema']['documents']}
                            form={form}
                            data={this.props.field['documents'] || []}
                            subDocumentFilters={subDocumentFilters}
                            title={title} index={index}
                            hideRemove={title && title === 'VIEW'}
                            hideEdit={true}
                            getAssetDocumentData={this.getAssetDocumentData}/>
                        )}
                    </Form.Item>
                </div>
            </div>
        }

        return (
            <>
                <div className='stock-taking-sublist'>
                    {formItems(index)}
                    <br/>
                </div>
            </>
        );
    }
}

export default SubList;
SubList.defaultProps = {};

SubList.propTypes = {
    item: PropTypes.object,
};
